import { render } from "./NovusCustomers.vue?vue&type=template&id=569f9c9f&scoped=true"
import script from "./NovusCustomers.vue?vue&type=script&lang=js"
export * from "./NovusCustomers.vue?vue&type=script&lang=js"

import "./NovusCustomers.vue?vue&type=style&index=0&id=569f9c9f&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569f9c9f"]])

export default __exports__